export default __webpack_public_path__ + "static/media/Astute Health Main Logo.9d6301a4.svg";